/**
* @module themeColor
* @author: zhangyemei
* @description: themeColor-主题颜色,fizeColor-字体颜色,headerBg-头部背景颜色,themeRgba-rgba主题色
* @since: 2019-12-20 17:24:44
*/
export const themeColor = {
  blue: {
    themeColor: '#008AFF',
    headerBg: '#008AFF',
    linearColor: '#1C4CFB',
    fizeColor: '#FFF',
    themeRgba: '0, 138, 255'
  },
  bluePale: {
    themeColor: '#00AAFF',
    headerBg: '#00AAFF',
    linearColor: '#00AAFF',
    fizeColor: '#FFF',
    themeRgba: '0, 170, 255'
  },
  cyan: {
    themeColor: '#00C5C3',
    headerBg: '#00C5C3',
    linearColor: '#00C5C3',
    fizeColor: '#FFF',
    themeRgba: '0, 197, 195'
  },
  cyanDeep: {
    themeColor: '#25C2B7',
    headerBg: '#25C2B7',
    linearColor: '#25C2B7',
    fizeColor: '#FFF',
    themeRgba: '37, 194, 183'
  },
  default: {
    themeColor: '#008AFF',
    headerBg: '#2A2A2A',
    linearColor: '#1C4CFB',
    fizeColor: '#FFF',
    themeRgba: '0, 138, 255'
  },
  gray: {
    themeColor: '#008AFF',
    linearColor: '#1C4CFB',
    headerBg: '#F8F9FA',
    fizeColor: '#2A2A2A',
    themeRgba: '0, 138, 255'
  },
  green: {
    themeColor: '#27B690',
    headerBg: '#27B690',
    linearColor: '#27B690',
    fizeColor: '#FFF',
    themeRgba: '39, 182, 144'
  },
  greenPale: {
    themeColor: '#2CC17B',
    headerBg: '#2CC17B',
    linearColor: '#2CC17B',
    fizeColor: '#FFF',
    themeRgba: '44, 193, 123'
  },
  orange: {
    themeColor: '#F7B000',
    headerBg: '#F7B000',
    linearColor: '#F7B000',
    fizeColor: '#FFF',
    themeRgba: '247, 176, 0'
  },
  orangeDeep: {
    themeColor: '#F79B19',
    headerBg: '#F79B19',
    linearColor: '#F79B19',
    fizeColor: '#FFF',
    themeRgba: '247, 155, 25'
  },
  red: {
    themeColor: '#F74C4C',
    linearColor: '#F53D2A',
    headerBg: '#F74C4C',
    fizeColor: '#FFF',
    themeRgba: '247, 76, 76'
  },
  redDeep: {
    themeColor: '#D6001C',
    headerBg: '#D6001C',
    linearColor: '#D6001C',
    fizeColor: '#FFF',
    themeRgba: '214, 0, 28'
  },
  white: {
    themeColor: '#008AFF',
    linearColor: '#1C4CFB',
    headerBg: '#FFF',
    fizeColor: '#2A2A2A',
    themeRgba: '0, 138, 255'
  }
};
export const footerThemeColor = {
  default: {
    themeColor: '#008AFF',
    fontColor: '#ededed',
    bgColor: '#2A2A2A',
    borderColor: '#404046',
    hoverFontColor: '#008AFF'
  },
  gray: {
    themeColor: '#E9E9E9',
    bgColor: '#E9E9E9',
    fontColor: '#666666',
    borderColor: '#DCDCDC',
    hoverFontColor: '#666666'
  },
  white: {
    themeColor: '#fff',
    bgColor: '#fff',
    fontColor: '#666666',
    borderColor: '#F0F0F1',
    hoverFontColor: '#666666'
  },
  red: {
    themeColor: '#D6001C',
    bgColor: '#fff',
    fontColor: '#666666',
    borderColor: '#F0F0F1',
    hoverFontColor: '#D6001C'
  },
  blue: {
    themeColor: '#008AFF',
    bgColor: '#fff',
    fontColor: '#666666',
    borderColor: '#F0F0F1',
    hoverFontColor: '#008AFF'
  },
  cyan: {
    themeColor: '#00C5C3',
    bgColor: '#fff',
    fontColor: '#666666',
    borderColor: '#F0F0F1',
    hoverFontColor: '#00C5C3'
  },
  green: {
    themeColor: '#27B690',
    bgColor: '#fff',
    fontColor: '#666666',
    borderColor: '#F0F0F1',
    hoverFontColor: '#27B690'
  },
  orange: {
    themeColor: '#F7B000',
    bgColor: '#fff',
    fontColor: '#666666',
    borderColor: '#F0F0F1',
    hoverFontColor: '#F7B000'
  }
};